module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.search', {
            url: '/search?{searchTerm}&{multisearchItems}&{pageNumber:int}&{sortBy}',
            onEnter: [
                '$q', '$state', '$stateParams', 'SearchPhraseActionService', 'SearchMultisearchService', 'SearchService', function ($q, $state, $stateParams, searchActionService, searchMultisearchService, searchService) {
                    $q.all([
                        searchActionService.getSearchPhraseAction($stateParams.searchTerm || ''),
                        $state.transition,
                        searchService.getSearchCounts($stateParams.searchTerm),
                    ]).then(([searchAction]) => {
                        if (searchAction && !searchMultisearchService.isSearchMultisearch()) {
                            return searchActionService.performSearchPhraseAction(searchAction);
                        }

                        return $q.resolve();
                    }).then(() => {
                        // If there are no *product* results for the search term but there are *other* results (specials, recipes, articles),
                        // this will figure out which state to redirect to. This must be called after getting the search counts
                        // in order to know which types of results are available for the search term.
                        const nextState = searchService.determineStateToShow($stateParams.searchTerm, $stateParams.multisearchItems);

                        if ($state.is('shop.search') && !$state.is(nextState.name)) {
                            $state.go(nextState.name, nextState.params, { location: 'replace' });
                        }
                    });
                },
            ],
            views: {
                'left-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-search-navigation
                            search-term="$ctrl.$state.params.searchTerm"
                            multisearch-items="$ctrl.$state.params.multisearchItems"
                            filter="$ctrl.$state.params.filter"
                            disable-navigation-links="false">
                        </wow-search-navigation>
                    `,
                },
                'rr-instrumentation-panel@root': {
                    controller: ['$stateParams', '$scope', function ($searchParams, $scope) {
                        $scope.searchTerm = $searchParams.searchTerm;
                    }],
                    template: '<wow-rr-search-instrumentation search-term="searchTerm"></wow-rr-search-instrumentation>',
                },
            },
            data: {
                pageMetadata: [
                    '$state', function ($state) {
                        return $state.params.searchTerm
                            ? {
                                title: `${$state.params.searchTerm} - Woolworths Online`,
                                metaDescription: `${$state.params.searchTerm} - Woolworths Online`,
                                metaRobot: 'noindex',
                            }
                            : {
                                title: 'Search - Woolworths Online',
                                metaDescription: 'Search - Woolworths Online',
                                metaRobot: 'noindex',
                            };
                    },
                ],
                authenticate: [
                    'SearchPhraseActionService', 'SearchMultisearchService', '$q', 'toParams', function (searchActionService, multisearchService, $q, toParams) {
                        const isMultisearch = toParams.multisearchItems && multisearchService.isSearchTermPartOfMultisearchList(toParams.searchTerm, toParams.multisearchItems);
                        if (toParams && toParams.searchTerm && !isMultisearch) {
                            return searchActionService.searchRequiresLogin(toParams.searchTerm);
                        }

                        return $q.when(false);
                    },
                ],
            },
        })
        .state('shop.search.products', {
            url: '/products?{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-search-product-tile-list
                                search-term="$ctrl.$state.params.searchTerm"
                                multisearch-items="$ctrl.$state.params.multisearchItems"
                                is-special="false"
                                is-list="false"
                                page-number="$ctrl.$state.params.pageNumber || 1"
                                sort-by="$ctrl.$state.params.sortBy"
                                filter="$ctrl.$state.params.filter">
                            </wow-search-product-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
            },
        })
        .state('shop.search.specials', {
            url: '/specials?{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-search-product-tile-list
                                search-term="$ctrl.$state.params.searchTerm"
                                is-special="true"
                                is-list="false"
                                page-number="$ctrl.$state.params.pageNumber || 1"
                                sort-by="$ctrl.$state.params.sortBy"
                                filter="$ctrl.$state.params.filter">
                            </wow-search-product-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
            },
        })
        .state('shop.search.zero-result', {
            url: '/zeroresult',
            views: {
                'left-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-search-navigation
                            search-term="$ctrl.$state.params.searchTerm"
                            multisearch-items="$ctrl.$state.params.multisearchItems"
                            filter="$ctrl.$state.params.filter"
                            disable-navigation-links="true">
                        </wow-search-navigation>
                    `,
                },
                'center-panel@shop': {
                    template: '<wow-search-zero-results></wow-search-zero-results>',
                },
            },
        })
        .state('shop.search.external-result', {
            url: '/externalresult',
            views: {
                'left-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-search-navigation
                            search-term="$ctrl.$state.params.searchTerm"
                            multisearch-items="$ctrl.$state.params.multisearchItems"
                            filter="$ctrl.$state.params.filter"
                            disable-navigation-links="true">
                        </wow-search-navigation>
                    `,
                },
                'center-panel@shop': {
                    template: '<wow-search-external-result></wow-search-external-result>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/search.js